import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'
import Heading from 'LuxKit/Typography/Heading'
import Typography from 'LuxKit/Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { replaceExperienceQueryString } from 'lib/experiences/experienceUtils'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import variables from 'styles/vendor/bootstrap/variables'
import ExperiencesPageEditorsPickList from './ExperiencesPageEditorsPickList'

const layoutContainerPadding = variables.gutterWidth / 2

const CardCarousel = styled.div`
  display: grid;
  grid-template-columns: repeat(3, ${rem(360)});
  gap: ${rem(20)};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: ${rem(4)} ${rem(layoutContainerPadding)} ${rem(4)} ${rem(layoutContainerPadding)};
  margin: -${rem(4)} -${rem(layoutContainerPadding)} -${rem(4)} -${rem(layoutContainerPadding)};

  &::-webkit-scrollbar {
    display: none;
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(3, 1fr);
    scrollbar-width: auto;

    &::-webkit-scrollbar {
      display: initial;
    }
  }
`

const EditorsPickCard = styled(Pane)`
  padding: ${rem(24)};
  border-radius: ${props => props.theme.borderRadius.M};

  > * + * {
    margin-top: ${rem(20)};
  }
`

interface Props {
  locations: Array<App.Place>
}

function ExperiencesPageEditorsPicks(props: Props) {
  const { locations } = props
  const intl = useIntl()

  return (
    <VerticalSpacer gap={20}>
      <Heading variant="heading3">
        {intl.formatMessage({
          id: 'NBLuIPdhVS',
          defaultMessage: 'Editor’s picks',
          description: 'Heading for the editor picks section on the experiences landing page',
        })}
      </Heading>
      <div>
        <CardCarousel>
          {locations.map(loc =>
            <EditorsPickCard key={loc.id}>
              <Heading variant="heading5">{loc.name}</Heading>
              <ExperiencesPageEditorsPickList place={loc} />
              <Typography align="end">
                <TextButton
                  kind="tertiary"
                  endIcon={<LineAngleRightBIcon />}
                  horizontalOutdent="end"
                  to={`/search/experiences?${replaceExperienceQueryString({ destinationId: loc.id, destinationName: loc.name })}`}
                >
                  {intl.formatMessage({
                    id: 'tpGvtEX+iz',
                    defaultMessage: 'Explore all {locationName}',
                    description: 'Button text to explore all experiences in a specific location',
                  }, { locationName: loc.name })}
                </TextButton>
              </Typography>
            </EditorsPickCard>,
          )}
        </CardCarousel>
      </div>
    </VerticalSpacer>
  )
}

export default ExperiencesPageEditorsPicks
